import {FC, useMemo} from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {getIsTodayString} from '@kcast-fe/core';

interface IProps {
  name: string;
  timestamp: string;
  showDate: boolean;
  isFirst: boolean;
  isSelected: boolean;
  onSelect: () => void;
}

const ThreadListItemFC: FC<IProps> = ({
  name,
  timestamp,
  showDate,
  isFirst,
  isSelected,
  onSelect
}) => {
  const tooltipId = useMemo(() => `Thread-${timestamp}`, [timestamp]);

  return (
    <Flex flexDirection={'column'} p={'0 16px 2px 0'}>
      {showDate && (
        <Box
          p={'8px'}
          mt={isFirst ? 0 : '12px'}
          mb={'12px'}
          fontWeight={600}
          color={'{colors.textPrimary}'}
        >
          {getIsTodayString(timestamp)}
        </Box>
      )}

      <Flex
        p={'4px 8px'}
        borderRadius={'4px'}
        alignItems={'center'}
        fontWeight={isSelected ? 600 : 'inherit'}
        color={isSelected ? '{colors.textPrimary}' : 'inherit'}
        bg={isSelected ? '{colors.bgMain}' : 'transparent'}
        _hover={{cursor: 'pointer', bg: '{colors.bgSurface}'}}
        data-testid={'thread-name'}
        data-tooltip-id={tooltipId}
        onClick={onSelect}
      >
        {name}
      </Flex>
    </Flex>
  );
};

export const ThreadListItem = ThreadListItemFC;
